import React from 'react';
import { Auth0Provider as Auth0ProviderSDK } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { AuthProvider as CustomAuthProvider } from './useAuth';

interface Auth0ProviderProps {
  children: React.ReactNode;
}

export const Auth0Provider: React.FC<Auth0ProviderProps> = ({ children }) => {
  const navigate = useNavigate();

  const domain = import.meta.env.AUTH0_DOMAIN as string;
  const clientId = import.meta.env.AUTH0_CLIENT_ID as string;
  const audience = import.meta.env.AUTH0_AUDIENCE as string;
  const redirectUri = (import.meta.env.AUTH0_CALLBACK_URL as string) || window.location.origin + '/callback';

  if (!domain || !clientId || !audience) {
    console.error('Auth0 environment variables are missing:', { domain, clientId, audience });
    return <div>Auth0 configuration error. Please check environment variables.</div>;
  }

  const onRedirectCallback = (appState?: { returnTo?: string }) => {
    // After successful login, redirect to home or the page they were trying to access
    const returnTo = appState?.returnTo || '/home';
    navigate(returnTo);
  };

  return (
    <Auth0ProviderSDK
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience: audience,
        scope: 'openid profile email',
        // Explicitly disable MFA/Guardian to avoid subscription errors
        max_age: 0,
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      skipRedirectCallback={false}
    >
      <CustomAuthProvider>
        {children}
      </CustomAuthProvider>
    </Auth0ProviderSDK>
  );
};
